var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileChromeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 2.02L14 2C11.8 2 10 3.8 10 6V42C10 44.2 11.8 46 14 46H34C36.2 46 38 44.2 38 42V6C38 3.8 36.2 2.02 34 2.02ZM34 38H14V10H34V38Z",
    fill: "#495058"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_206_1005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 24C16.9972 22.7699 17.3235 21.5615 17.945 20.5L20.945 25.74V25.77C21.2568 26.3019 21.7035 26.742 22.2399 27.0458C22.7764 27.3495 23.3836 27.5062 24 27.5C24.3193 27.4975 24.6369 27.4538 24.945 27.37L22.915 30.87C21.2744 30.6126 19.7787 29.7804 18.6952 28.5219C17.6116 27.2634 17.0108 25.6606 17 24Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 31L27.03 25.75C27.4179 25.0771 27.5709 24.2943 27.465 23.5249C27.3591 22.7554 27.0002 22.0431 26.445 21.5H30.53C30.9351 22.5594 31.0766 23.7013 30.9426 24.8275C30.8085 25.9538 30.4028 27.0305 29.7603 27.9652C29.1178 28.8999 28.2579 29.6644 27.2545 30.1931C26.251 30.7217 25.1342 30.9986 24 31Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 26.5C25.3807 26.5 26.5 25.3807 26.5 24C26.5 22.6193 25.3807 21.5 24 21.5C22.6193 21.5 21.5 22.6193 21.5 24C21.5 25.3807 22.6193 26.5 24 26.5Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8898 20.3882L23.8282 20.3891C23.0515 20.3897 22.2971 20.6485 21.6837 21.125C21.0703 21.6014 20.6328 22.2684 20.4401 23.0208L18.3976 19.483C19.1125 18.6026 20.0307 17.909 21.073 17.462C22.1154 17.015 23.2508 16.828 24.3815 16.917C25.5121 17.0061 26.6042 17.3685 27.5638 17.9732C28.5233 18.5779 29.3216 19.4066 29.8898 20.3882Z",
    fill: "#F44336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_206_1005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileChromeIcon);
export default __webpack_public_path__ + "static/media/mobile_chrome_icon.000f9e00.svg";
export { ForwardRef as ReactComponent };